import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../globalStyle/GlobalStyle";
import { PageStyle } from "./styled";
import { Card } from "../../layout/AuthLayout.styled";

function PageNotFound() {
	const navigate = useNavigate();
	return (
		<PageStyle>
			<Card>
				<h1>404 ERROR</h1>
				<p>The page you are looking for does not exist</p>
				<Button
					onClick={() => {
						navigate("/");
					}}>
					Go Back
				</Button>
			</Card>
		</PageStyle>
	);
}

export default PageNotFound;
